import {html, css, LitElement, nothing} from 'lit';
import {ScopeBinding} from './behaviors/keli-binding-behavior.js';
import '@shoelace-style/shoelace/dist/components/color-picker/color-picker.js';

class KeliColorPicker extends ScopeBinding(LitElement) {
  static styles = css`
    #label {
      position: static !important;
      font-size: 1em !important;
      cursor: default;
      display: block;
      font-weight: 300 !important;
      color: var(--keli-field-label-color)
    }
  `;

  static keliControlTypes = ['colorpicker'];
  static needsDataLoaded = true;
  static properties = {
    caption: {type: String, scopeVar: true},
    currentValue: {type: String, state: true},
    displayValue: {type: String, scopeVar: true},
    swatches: {type: Array, scopeVar: true},
  };

  constructor() {
    super();
    this.addEmitToKeli(['keliFocus', 'keliBlur', 'keliAccepted']);
  }

  updated(changedProperties) {
    super.updated(changedProperties);

    if (changedProperties?.has('displayValue')) {
      this.currentValue = this.displayValue;
    }
  }

  render() {
    return html`
        <label id="label" for="input">${this.caption ?? nothing}</label>
        <sl-color-picker
                id="input"
                size="large"
                format="hex"
                uppercase
                no-format-toggle
                swatches="${this.swatches?.length ? this.swatches.join(';') : nothing}"
                value="${this.currentValue ?? nothing}"
                @sl-blur="${this.handleBlur}"
                @sl-change="${this.handleChange}"
                @sl-focus="${this.handleFocus}"></sl-color-picker>`;
  }

  handleBlur(event) {
    this.dispatchEvent(new CustomEvent('keliBlur', {bubbles: true, composed: true, detail: {element: this, event}}));
    this._keliAccept(event);
  }

  handleChange(event) {
    this.currentValue = this.renderRoot.querySelector('#input').value;
    this._keliAccept(event);
  }

  handleFocus(event) {
    this.dispatchEvent(new CustomEvent('keliFocus', {bubbles: true, composed: true, detail: {element: this, event}}));
  }

  _keliAccept(event) {
    const newValue = this.currentValue;
    const oldValue = this.displayValue;

    if (newValue !== oldValue) {
      this.displayValue = newValue;
      this.dispatchEvent(new CustomEvent('keliAccepted', {detail: {element: this, value: newValue, event}}));
    }
  }
}

customElements.define('keli-color-picker', KeliColorPicker);